import React from "react";
import Layout from "../../reusables/layout/layout";
import RegisterTedac from "../../Component/registerform/registerTedac";

const PaymentRegisterBece = () => {
  return (
    <div>
      <Layout>
        <RegisterTedac
          examType={"TEDAC REGISTRATION"}
          // serviceType={"tedac"}
          url={"/auth/tedac/signup"}
          navigateTo={"/tedac/payment/login"}
          homeLink={"https://tedac.examsboard.lagosstate.gov.ng/"}
        />
      </Layout>
    </div>
  );
};

export default PaymentRegisterBece;
